<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">Видео</h2>
      </div>
      <div class="d-flex">
        <div class="justify-content-center">
          <router-link to="/video/add" type="button" class="btn btn-primary my-2 btn-icon-text">
            <i class="fe fe-plus-square mr-2"></i> Добавить видео
          </router-link>
        </div>
      </div>
    </div>
    <div class="row row-sm">
      <div class="col-lg-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Список видео</h6>
            </div>
            <div class="table-responsive">
              <b-table striped hover :items="videosList" :fields="tableFields">
                <template #cell(image_paths)="row">
                  <div v-if="row.item.image_paths">
                    <img class="img-thumbnail table-image" :src="row.item.image_paths.small" alt="image">
                  </div>
                </template>
                <template #cell(description)="row">
                  <div v-html="row.item.description[$i18n.locale]"></div>
                </template>
                <template #cell(status)="row">
                  <span class="badge text-white" :class="{'bg-success': row.item.status === 'active', 'bg-danger': row.item.status !== 'active'}">{{row.item.status}}</span>
                </template>
                <template #cell(actions)="row">
                  <router-link :to="`video/${row.item.id}`" class="btn btn-outline-primary mr-2 mt-1 mb-1">
                    <i class="fe fe-edit"></i>
                  </router-link>
                  <button v-if="row.item.status === 'active'" @click="deleteCreatedVideo(row.item.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">
                    <i class="ti-close"></i>
                  </button>
                  <div v-else class="d-inline-block">
                    <button @click="restoreVideoInList(row.item.id)" type="button" class="btn btn-outline-success mr-2 mt-1 mb-1">
                      <i class="fe fe-rotate-ccw"></i>
                    </button>
                    <button @click="deleteCreatedVideo(row.item.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">
                      <i class="fe fe-trash-2"></i>
                    </button>
                  </div>
                </template>
              </b-table>
              <div class="d-flex justify-content-end  mt-3">
                <div class="mr-3">
                  <b-form-select
                    @change="changePaginationPerPage"
                    style="width: 80px"
                    v-model="paginationPerPage"
                    :options="paginationOptions"
                  >
                  </b-form-select>
                </div>
                <div>
                  <b-pagination
                    class="m-0"
                    @change="changePagination"
                    v-model="paginationCurrentPage"
                    :total-rows="pagination.count"
                    :per-page="paginationPerPage"
                    first-text="<<"
                    prev-text="<"
                    next-text=">"
                    last-text=">>"
                  ></b-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Swal from 'sweetalert2'

export default {
  name: 'Videos',
  data () {
    return {
      paginationOptions: [
        { value: 6, text: '6' },
        { value: 10, text: '10' },
        { value: 30, text: '30' },
        { value: 100, text: '100' }
      ],
      paginationCurrentPage: 1,
      paginationPerPage: 6,
      pagination: {}
    }
  },
  computed: {
    ...mapState({
      videosList: state => state.videos.videosList
    }),
    tableFields () {
      return [
        {
          key: 'id',
          label: 'Id',
          sortable: true
        },
        {
          key: 'image_paths',
          label: 'Фото',
          sortable: true
        },
        {
          key: 'title.' + this.$i18n.locale,
          label: 'Название',
          sortable: true
        },
        {
          key: 'description.' + this.$i18n.locale,
          label: 'Описание',
          sortable: true
        },
        {
          key: 'status',
          label: 'статус',
          sortable: true
        },
        {
          key: 'actions',
          label: 'действие',
          sortable: false
        }
      ]
    }
  },
  created () {
    this.getVideos({})
  },
  methods: {
    ...mapActions({
      getAllVideos: 'videos/getAllVideos',
      deleteVideo: 'videos/deleteVideo',
      restoreVideo: 'videos/restoreVideo'
    }),
    changePaginationPerPage (value) {
      this.getAllVideos({ page: this.paginationCurrentPage, count: value })
    },
    changePagination (page) {
      this.getAllVideos({ page: page, count: this.paginationPerPage })
    },
    getVideos (params) {
      this.getAllVideos(params).then(res => {
        this.pagination = res.pagination
      }).catch(() => {
        this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
      })
    },
    deleteCreatedVideo (id) {
      Swal.fire({
        text: this.$t('messages.warning.delete'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#748C41',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then((result) => {
        if (result.value) {
          this.deleteVideo({ id }).then(res => {
          }).catch(() => {
            this.$toasted.error(this.$t('messages.error.somethingWentWrong')).goAway(1500)
          })
        }
      })
    },
    restoreVideoInList (id) {
      this.restoreVideo({ id }).then(res => {
      })
    }
  }
}
</script>
